<template>
    <tr>
        <td>{{row.id}}</td>
        <td>{{row.userId}}</td>
        <td>{{row.amount}} {{currencyMap[row.currency]}}</td>
        <td><span :class="`${row.status} status`">{{row.status}}</span></td>
        <td>{{row.paymentSystem}}</td>
        <td>{{row.paymentGmGateway}}</td>
        <td>{{row.paymentSystemInvoice ? row.paymentSystemInvoice : '-'}}</td>
        <td>{{row.profitInvoice}}</td>
        <td>{{row.receivedInRubbles ? row.receivedInRubbles : "-"}}</td>
        <td>{{parseDate(row.creationDateTime)}}</td>
        <td>
            <div class="compliance"
                 :class="{
                  ok: row.isStatusApproved,
                  error: row.isStatusApproved === false,
                  pending: row.isStatusApproved === null,
            }">
                <img
                        v-if="row.isStatusApproved"
                        src="../../assets/images/compliance/ok.svg"
                        alt=""
                />
                <img
                        v-if="row.isStatusApproved === false"
                        src="../../assets/images/compliance/error.svg"
                        alt=""
                />
                <img
                        v-if="row.isStatusApproved === null"
                        src="../../assets/images/compliance/pending.svg"
                        alt=""
                />
            </div>
        </td>
    </tr>
</template>

<script>
export default {
    name: "TableRowRights",
    props: ['row'],
    data() {
        return{
            currencyMap: {
                rub: '₽',
                usd: '$',
                eur: '€'
            },
        }
    },
    methods: {
        parseDate(date) {
            const d = new Date(date);

            d.setMinutes(d.getMinutes() + -d.getTimezoneOffset());

            return d.toLocaleString("ru-RU", {
                timeZone: "Europe/Moscow",
                weekday: "long",
                year: "numeric",
                month: "long",
                day: "numeric",
                hour: "numeric",
                minute: "numeric",
                second: "numeric",
            });
        },
    }
}
</script>
